module.exports = __webpack_public_path__ + "img/header_img_01.11967722.png";